import { createTheme as createMuiTheme } from "@mui/material/styles";

const theme = createMuiTheme({
  palette: {
    primary: { main: "#0D47A1" },
    secondary: { main: "#D32F2F" },
    background: { default: "#FFFFFF" },
    info: { main: "#FFEB3B" },
    success: { main: "#830095" },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
  spacing: 4,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
